export default __webpack_public_path__ + "static/laveLingeZoomDesktop-8f2cb31a1ae98ad076f742a03d20aae3.png";